import { render, staticRenderFns } from "./create-fee-sheet-from-template.vue?vue&type=template&id=36871011&scoped=true&"
import script from "./create-fee-sheet-from-template.vue?vue&type=script&lang=ts&"
export * from "./create-fee-sheet-from-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36871011",
  null
  
)

export default component.exports